import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getInvoiceCountReport } from "../../services/fullinvoice.services";

// Async Thunk for fetching the invoice count report data
export const fetchInvoiceCountReport = createAsyncThunk(
  "invoiceCountReport/fetchReport",
  async (groupBy, { rejectWithValue }) => {
    try {
      const data = await getInvoiceCountReport(groupBy);
      return data; // Returning the data from the API response
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const invoiceCountReportSlice = createSlice({
  name: "invoiceCountReport",
  initialState: {
    data: null, // Holds the invoice count report data
    status: "idle", // idle | loading | succeeded | failed
    error: null, // Holds any error message
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoiceCountReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchInvoiceCountReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload; // Storing the fetched data
      })
      .addCase(fetchInvoiceCountReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload; // Storing the error message
      });
  },
});

export default invoiceCountReportSlice.reducer;
